<!-- angular component
    privado > sitio privado
    simple > procesos, pasos, aplicativos
 
    --->
    
<app-header [tipo]="'simple'"></app-header>

<!-- ******************** -->
<router-outlet></router-outlet>

<!-- angular component --->
<app-footer [tipo]="'simple'"></app-footer>
 